// extracted by mini-css-extract-plugin
module.exports = {"lds-dual-ring":"Spinner_lds-dual-ring__dGI5O","textsizespinner":"Spinner_textsizespinner__7gY_Y"};